const ROLE_LABELS = {
  MEMBER: 'Участник',
  ADMIN: 'Администратор',
  MENTOR: 'Наставник',
  TRACK_COORDINATOR: 'Координатор треков',
};

export function getRoleLabel(role) {
  return ROLE_LABELS[String(role || '').toUpperCase()] || role || 'Пользователь';
}

export function isAdminLikeRole(role) {
  const normalized = String(role || '').toUpperCase();
  return normalized === 'ADMIN' || normalized === 'TRACK_COORDINATOR';
}

export function participatesInRating(role) {
  const normalized = String(role || '').toUpperCase();
  return normalized !== 'ADMIN' && normalized !== 'TRACK_COORDINATOR' && normalized !== 'MENTOR';
}

export function canReceiveYufunts(role) {
  return String(role || '').toUpperCase() !== 'MENTOR';
}
